import { Observable, Subject } from 'rxjs';

import { GridType } from '../../core/template-definition.model';
import { GridTab } from '../../main-page/grid-tab.model';

import { ScorecardSelection } from './team-grid.model';

export interface ScorecardComponentComm {
    bridgeCreateTab: (selection: ScorecardSelection) => void;
    bridgeIsExporting: () => boolean;
}

// TODO rename ^on.* methods to action verbs instead of event verbs
export interface GridComm {
    onTabChange: (tabRefId: GridTab) => void;
}

// TODO rename ^on.* methods to action verbs instead of event verbs
export interface TeamgridComponentComm {
    onTabChange: (evt: GridType) => void;
    toggleExpandAll: () => void;
    expandAllChange: () => Observable<boolean>;

    /* TODO revise.
        workaround for filter overlay flicker when target element is no longer visible when switching tabs */
    willBeHidden: () => void;
}

interface ScorecardConnector<TComm> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    connect: <T extends TComm>(instance: TComm) => void;
    disconnect: () => void;
    connected: () => boolean;
}

interface ScorecardComponentCommInternal
    extends ScorecardConnector<ScorecardComponentComm>,
        ScorecardComponentComm {}

interface GridCommInternal extends ScorecardConnector<GridComm>, GridComm {}

interface TeamgridComponentCommInternal
    extends ScorecardConnector<TeamgridComponentComm>,
        TeamgridComponentComm {}

export class ScoredardBridgeService {
    private _componentScorecard: ScorecardComponentComm;
    private _grid: GridComm;
    private _componentTeamgrid: TeamgridComponentComm;

    /** this might not be kept */
    private readonly _connectObservable: Subject<ScorecardConnector<any>>;
    observableForConnect(): Observable<ScorecardConnector<any>> {
        return this._connectObservable.asObservable();
    }

    constructor() {
        this._connectObservable = new Subject();
    }

    componentScorecard: ScorecardComponentCommInternal = {
        connect: (value: ScorecardComponentComm): void => {
            this._componentScorecard = value;
        },
        disconnect: (): void => {
            this._componentScorecard = null;
        },
        connected: (): boolean => {
            return !!this._componentScorecard;
        },
        bridgeCreateTab: (selection: ScorecardSelection): void => {
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            if (
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                this._componentScorecard &&
                this._componentScorecard.bridgeCreateTab
            ) {
                this._componentScorecard.bridgeCreateTab(selection);
            }
            // eslint-disable-next-line no-useless-return
            return;
        },
        bridgeIsExporting: (): boolean => {
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            if (
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                this._componentScorecard &&
                this._componentScorecard.bridgeIsExporting
            ) {
                return this._componentScorecard.bridgeIsExporting();
            }
            return undefined;
        },
    };

    componentTeamgrid: TeamgridComponentCommInternal = {
        connect: (value: TeamgridComponentComm): void => {
            this._componentTeamgrid = value;
            this._connectObservable.next(
                value as TeamgridComponentCommInternal,
            );
        },
        disconnect: (): void => {
            this._componentTeamgrid = null;
        },
        connected: (): boolean => {
            return !!this._componentTeamgrid;
        },
        onTabChange: (evt: GridType): void => {
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            if (
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                this._componentTeamgrid &&
                this._componentTeamgrid.onTabChange
            ) {
                this._componentTeamgrid.onTabChange(evt);
            }
            // eslint-disable-next-line no-useless-return
            return;
        },
        toggleExpandAll: (): void => {
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            if (
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                this._componentTeamgrid &&
                this._componentTeamgrid.toggleExpandAll
            ) {
                this._componentTeamgrid.toggleExpandAll();
            }
            return undefined;
        },
        expandAllChange: (): Observable<boolean> => {
            if (this._componentTeamgrid) {
                return this._componentTeamgrid.expandAllChange();
            }
            return undefined; // explicit undefined
        },
        willBeHidden: (): void => {
            this._componentTeamgrid?.willBeHidden();
        },
    };

    grid: GridCommInternal = {
        connect: (value: GridComm): void => {
            this._grid = value;
        },
        disconnect: (): void => {
            this._grid = null;
        },
        connected: (): boolean => {
            return !!this._grid;
        },
        onTabChange: (tabRefId: GridTab): void => {
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            if (this._grid && this._grid.onTabChange) {
                this._grid.onTabChange(tabRefId);
            }
            // eslint-disable-next-line no-useless-return
            return;
        },
    };

    dispose(): void {
        this._componentScorecard = null;
        this._grid = null;
        this._componentTeamgrid = null;

        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._connectObservable && this._connectObservable.complete();
    }
}
